import { Children } from 'react';
import { componentName, isSeries } from './chartUtils';
import AreaDifferenceSeries from '../series/AreaDifferenceSeries';
export default function collectDataFromChildSeries(children) {
  var allData = [];
  Children.forEach(children, function (Child) {
    if (Child && Child.props) {
      var data = Child.props.data;
      var name = componentName(Child);

      if (name === AreaDifferenceSeries.displayName) {
        allData = allData.concat(collectDataFromChildSeries(Child.props.children));
      } else if (data && isSeries(name)) {
        allData = allData.concat(Child.props.data);
      }
    }
  });
  return allData;
}